<template>
  <table id="table" border="1" cellpadding="0" cellspacing="0" style="width:100%">
    <caption id="tablePrintText">
      <div style="font-weight:600;letter-spacing:0px">{{hotelInfo.name}}</div>
      <div style="font-weight:600">菜品销售榜</div>
      <div style="display: flex;justify-content:space-between;">
        <div>
          <span style="font-weight:600" v-if="queryShiftValue != ''">班次:{{queryShiftValue == 1 ? '早班' : queryShiftValue == 2 ? '中班' :queryShiftValue == 3 ? '晚班':queryShiftValue == 4 ? '夜班':'所有' }} </span>
          <span style="font-weight:600">营业日期:{{listQuery.startTime}} 至 {{listQuery.endTime}}</span>
                   
        </div>
        <div>
          <span style="font-weight:600">打印人:{{employee.name}}</span>
          <span style="font-weight:600">打印时间:{{currentTime}}</span>
        </div>
      </div>
    </caption>
    <thead>
      <tr v-if="exportShow">
        <th colspan="13">{{hotelInfo.name}}</th>
      </tr>
      <tr v-if="exportShow">
        <th colspan="13">菜品销售榜</th>
      </tr>
      <tr v-if="exportShow">
        <th colspan="6">
          <div style="font-weight:600;textAlign:left">
            <template>营业日期:{{listQuery.startTime}} 至 {{listQuery.endTime}}</template>
          </div>
        </th>
        <th style="text-align:right" colspan="7">打印人:{{employee.name}} 打印时间:{{currentTime}}</th>
      </tr>
      
      <tr>
        <th v-for="(item,index) in nameTitle" :key="index" @click="handleSort(item.key)" style="position:sticky;top:0;background-color:#fff;">{{item.name}}</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="tr in list" :key="tr.code">
        <td align="center">{{tr.outletName}}</td>
        <td align="center">{{tr.bookName}}</td>
        <td align="center">{{tr.typeCode}}</td>
        <td align="center">{{tr.typeName}}</td>
        <td align="center">{{tr.dishesCode}}</td>
        <td align="center">{{tr.food_name}}</td>
        <td align="center">{{tr.quantity * 1  == 0 ? '' : tr.quantity}}</td>
        <td align="center">{{tr.price?tr.price.toFixed(2):'0.00'}}</td>
        <td align="center">{{tr.discount?tr.discount.toFixed(2):'0.00'}}</td>
        <td align="center">{{tr.tax?tr.tax.toFixed(2):'0.00'}}</td>
        <td align="center">{{tr.server_price?tr.server_price.toFixed(2):'0.00'}}</td>
        <!-- <td align="center">{{tr.discount_price?tr.discount_price.toFixed(2):'0.00'}}</td> -->
        <td align="center">{{tr.all_price?tr.all_price.toFixed(2):'0.00'}}</td>
        <td align="center">{{tr.all_price?tr.all_price.toFixed(2):'0.00'}}</td>
      </tr>
      <tr v-if="list.length > 0">
        <td align="center">合计</td>
        <td align="center"></td>
        <td align="center"></td>
        <td align="center"></td>
        <td align="center"></td>
        <td align="center"></td>
        <td align="center">{{sumsTotal.quantity}}</td>
        <!-- <td align="center">{{sumsTotal.price?sumsTotal.price.toFixed(2):'0.00'}}</td> -->
        <!-- // 单价 -->
        <td align="center"></td>
        <td align="center">{{sumsTotal.discount?sumsTotal.discount.toFixed(2):'0.00'}}</td>
        <td align="center">{{sumsTotal.tax?sumsTotal.tax.toFixed(2):'0.00'}}</td>
        <td align="center">{{sumsTotal.server_price?sumsTotal.server_price.toFixed(2):'0.00'}}</td>
        <!-- <td align="center">{{sumsTotal.discount_price?sumsTotal.discount_price.toFixed(2):'0.00'}}</td> -->
        <td align="center">{{sumsTotal.all_price?sumsTotal.all_price.toFixed(2):'0.00'}}</td>
        <td align="center">{{sumsTotal.all_price?sumsTotal.all_price.toFixed(2):'0.00'}}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import DateUtils from '@/utils/DateUtils';
export default {
  props: {
    tabelList: {
      type: Array,
      default: []
    },
    sumsTotal: {
      type: Object,
    },
    listQuery: {
      type: Object,
    },
    exportShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    list() {
      return this.tabelList
    }
  },
  data() {
    return {
       employee:JSON.parse(localStorage.getItem('user')),
      currentTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd hh:mm"), //当前的时间
      hotelInfo:JSON.parse(localStorage.getItem('hotel')),
      nameTitle: [
        { name: '营业点', key: 'outletName' },
        { name: '菜谱名称', key: 'bookName' },
        { name: '菜类编号', key: 'typeCode' },
        { name: '菜类', key: 'typeName' },
        { name: '菜品编码', key: 'dishesCode' },
        { name: '名称', key: 'food_name' },
        { name: '数量', key: 'quantity' },
        { name: '单价', key: 'price' },
        { name: '折扣', key: 'discount' },
        { name: '税', key: 'tax' },
        { name: '服务费', key: 'server_price' },
        { name: '应收', key: 'discount_price' },
        { name: '实收', key: 'all_price' },
      ],
      sort: false,
      queryShiftValue: '',
    }
  },
  methods: {
    //排序
    handleSort(val) {
      if (this.sort) {
        if (typeof (this.list[0][val]) == 'number') {
          this.list.sort(function (a, b) {
            return a[val] - b[val]
          })
        } else {
          this.list.sort(
            function compareFunction(param1, param2) {
              return param1[val].localeCompare(param2[val], 'zh-Hans-CN', { sensitivity: 'accent' });
            }
          )
        }
        this.sort = false
      } else {
        if (typeof (this.list[0][val]) == 'number') {
          this.list.sort(function (a, b) {
            return b[val] - a[val]
          })
        } else {
          this.list.sort(
            function compareFunction(param1, param2) {
              return param2[val].localeCompare(param1[val], 'zh-Hans-CN', { sensitivity: 'accent' });
            }
          )
        }
        this.sort = true
      }
    },
    
  },
  mounted(){
    this.$bus.$on('renderQueryShiftValue', val =>{
      this.queryShiftValue = val;
    });
  }

}
</script>